module.exports = __webpack_public_path__ + "img/logo2.18c78582.png";